export const STATES = [
  { id: "AL", name: "Alabama (AL)" },
  { id: "AK", name: "Alaska (AK)" },
  { id: "AZ", name: "Arizona (AZ)" },
  { id: "AR", name: "Arkansas (AR)" },
  { id: "CA", name: "California (CA)" },
  { id: "CO", name: "Colorado (CO)" },
  { id: "CT", name: "Connecticut (CT)" },
  { id: "DE", name: "Delaware (DE)" },
  { id: "DC", name: "District Of Columbia (DC)" },
  { id: "FL", name: "Florida (FL)" },
  { id: "GA", name: "Georgia (GA)" },
  { id: "HI", name: "Hawaii (HI)" },
  { id: "ID", name: "Idaho (ID)" },
  { id: "IL", name: "Illinois (IL)" },
  { id: "IN", name: "Indiana (IN)" },
  { id: "IA", name: "Iowa (IA)" },
  { id: "KS", name: "Kansas (KS)" },
  { id: "KY", name: "Kentucky (KY)" },
  { id: "LA", name: "Louisiana (LA)" },
  { id: "ME", name: "Maine (ME)" },
  { id: "MD", name: "Maryland (MD)" },
  { id: "MA", name: "Massachusetts (MA)" },
  { id: "MI", name: "Michigan (MI)" },
  { id: "MN", name: "Minnesota (MN)" },
  { id: "MS", name: "Mississippi (MS)" },
  { id: "MO", name: "Missouri (MO)" },
  { id: "MT", name: "Montana (MT)" },
  { id: "NE", name: "Nebraska (NE)" },
  { id: "NV", name: "Nevada (NV)" },
  { id: "NH", name: "New Hampshire (NH)" },
  { id: "NJ", name: "New Jersey (NJ)" },
  { id: "NM", name: "New Mexico (NM)" },
  { id: "NY", name: "New York (NY)" },
  { id: "NC", name: "North Carolina (NC)" },
  { id: "ND", name: "North Dakota (ND)" },
  { id: "OH", name: "Ohio (OH)" },
  { id: "OK", name: "Oklahoma (OK)" },
  { id: "OR", name: "Oregon (OR)" },
  { id: "PA", name: "Pennsylvania (PA)" },
  { id: "RI", name: "Rhode Island (RI)" },
  { id: "SC", name: "South Carolina (SC)" },
  { id: "SD", name: "South Dakota (SD)" },
  { id: "TN", name: "Tennessee (TN)" },
  { id: "TX", name: "Texas (TX)" },
  { id: "UT", name: "Utah (UT)" },
  { id: "VT", name: "Vermont (VT)" },
  { id: "VA", name: "Virginia (VA)" },
  { id: "WA", name: "Washington (WA)" },
  { id: "WV", name: "West Virginia (WV)" },
  { id: "WI", name: "Wisconsin (WI)" },
  { id: "WY", name: "Wyoming (WY)" }
];
